import { useState } from "react";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import { downloadUploadedItem } from "../../utils/Common";
import PaymentDetailTableModal from "./PaymentDetailTableModal";
import { Modal } from "react-bootstrap";
import InvoiceTbl from "../../contants/tables/InvoiceTbl";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import toastNotify from "../../utils/ToastNotify";

const InvoiceDetailTableModal = ({
  data, // API data
  isOpen,
  handleInvoiceMdl
}) => {
  const [apidataPayment, setApiDataPayment] = useState([]);
  const [isPaymentDetailMdl, setIsPaymentDetailMdl] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const dispatch = useDispatch();

  const handleIsPaymentDetailMdl = (data) => {
    setIsPaymentDetailMdl(!isPaymentDetailMdl);
    setSelectedInvoice(data || null)
  }

  async function invoicegenrate(value, INVOICETYPE) {
    try {
      dispatch(handleLoader(true));
      const data = {
        INVOICE_TRAN_CD: value.TRAN_CD,
        INVOICE_SIGN_VIEW: INVOICETYPE,
      };
      const result = await makeRequest(
        "POST",
        urls.getClientInvoiceDtl,
        data,
        {}
      );
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0];
        downloadUploadedItem(
          `data:application/pdf;base64,${response}`,
          value.INVOICE_NO
        );
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  }


  async function fetchPaymentData(value) {
    try {
      dispatch(handleLoader(true));

      const data = {
        INVOICE_TRAN_CD: value.TRAN_CD,
      };
      const result = await makeRequest("POST", urls.getPaymentDtl, data, {}, {});

      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setApiDataPayment(response);
        handleIsPaymentDetailMdl(value);
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }


  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        size="xl"
        show={isOpen}
        onHide={handleInvoiceMdl}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InvoiceTbl
            data={data}
            invoicegenrate={invoicegenrate}
            handlepaymentDetail={fetchPaymentData}
          />
        </Modal.Body>
      </Modal>

      {isPaymentDetailMdl && (
        <PaymentDetailTableModal
          data={apidataPayment}
          isOpen={isPaymentDetailMdl}
          handleIsPaymentDetailMdl={handleIsPaymentDetailMdl}
          selectedInvoice={selectedInvoice}
        />
      )}
    </>
  );
};

export default InvoiceDetailTableModal;
